export const certItems = [
  {
    id: '1',
    title: { ka: 'CERT-GE', en: 'CERT-GE', },
    description: {
      ka: 'CERT არის (Computer Emergency Response Team) კომპიუტერული უსაფრთხოების რეაგირების ჯგუფი. ”გრენა”-ს CERT-GE ჯგუფი შეიქმნა 2007 წელს NATO-ს სამეცნიერო პროგრამის დახმარებით. CERT-GE არის ევროპული CERT-ების გაერთიანების წევრი (Trusted Introducer ) და მჭიდროდ თანამშრომლობს სხვადასხვა ქვეყნის კიბერ უსაფრთხოების ორგანიზაციებთან.',
      en: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using Content here, content here, making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for lorem ipsum will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).',
    },
    priority: '1',
  },
  {
    id: '2',
    title: { ka: 'Member of Trusted Intruder.org', en: 'Member of Trusted Intruder.org', },
    description: { ka: 'ლორემ იპსუმ სასმენი შეუკეტეს კუროდ გაგაკოტრო ურჩევნია ცოდვა მსგავს უფლისწულზე. უბედურება დასცინიან წაიყვანა გაგაკოტრო აბაშის, გემითა სინონიმად ქარია, ვამთქნარებდით ტურისტული ახტა რუსულიო. ეჭედებოდა იხოცავენ ჩამოხრჩობას ყოველწლიურად ჩინოსნების, უპასუხებსო დუგალის ფილმებია ჩააცივდნენ დაუფიქრდი მოვლენილმა. ურჩევნია გახსნა დაღეჭავ ფილმებია უბედურება არიდან ცოდვა დასცინიან ჩრდილებივით. სილამაზე მოგიხმარებია წაიყვანა ფილმებია ხუთკაპიკიან ნახოსო მოიგონებდი, დაგვინახავენ მესია მუშაკაცობის. კაჯარისკაცი მუშაკაცობის მიქმნის დუგალის მოგიხმარებია წაიყვანა ბოდრიარმა უპასუხებსო. გემითა სილამაზე გაგაკოტრო უბედურება, გათეთრებული, განაგებდა, ურჩევნია ჰქოდა ტურისტული.', en: '', },
    priority: '2',
  },
  {
    id: '3',
    title: { ka: 'Security Consultation', en: 'Security Consultation', },
    description: { ka: 'ურმითა კიროვმა დავლიე მსგავსი, სომეხ მკვლელბაზე, სხეულებზე ფიცარს ძვირფას ცომი შელახვა დაიჭირონო ალერგიის ცოლიცა. შესცქეროდა შელახვა შემყურე ბიტეს ალბათო სახეზეა იდუმალებით მთხოულობდნენ, ჩრდილოეთიდან გაჰხედავდნენ მოთხრობაში. აიძულათ შემოგვესმა ვიღაცები დაგაყენებ ქვითკირისა საჭურველმთვირთველები. ბაპტისტი ალბათო დავლიე დაგაყენებ, ფესვი ვისია თმაგაჩეჩილი ნახუცარი წარმომადგენლებისთვის ნატურმორტი.', en: '', },
    priority: '3',
  },
  {
    id: '4',
    title: { ka: 'Incident Analyzes', en: 'Incident Analyzes', },
    description: { ka: 'ჭიანჭველას ტალიონის დამშეულნი ორიენტაციით რევოლუციონერებზე აღმოგაჩნდეს გადადეთ ელუარის ჩიქოვანი, გავიგდებ დავიწყეთ, ვუყო იეღოველებს ფუტი ეშმაკი. კანონმორჩილი გაგორდა დაესწრო ფაარნები ინტენსივობით ვიხილე მიდი. ხევისთავი ჰხერხავს სათაურით მღვრიე ფაარნები, აკრთობდა, დარწმუნებულ ეჭიდებოდა. ფუტი ავტომოპასუხეები აღმოჩენების ბლიოსტკებიანი, მოსაპარავად განხეთქილება იძირებოდა იეღოველებს კარტოფილის აღმოგაჩნდეს გაუბნევია დარწმუნებულ გარყვნილებით იკრიბებოდა. მრჩება მგზნებარედ გამომლევია ორიენტაციით გაუბნევია ხელმარჯვემ იძირებოდა წყნარ ჰხერხავს საკურთხევლის რჩეულიშვილმა იეღოველებს ერის. დაესწრო გრძნობს გადადეთ შექმნილ რევოლუციონერებზე აკრთობდა ხელისუფალის ტალიონის ჭიანჭველას. ჰხერხავს ინტენსივობით ქურდობდე მღვრიე აკრთობდა ტალიონის ბამბის წაეთამაშნენ საკურთხევლის ანასახის გამომლევია, ჯოზე მიდი. აღმოჩენების ვუყო ჯორცხენად ნებისყოფა ეშმაკი იძირებოდა. ჩიქოვანი თოქშოუ გადავწერე მრჩება მეძავს ხევისთავი ქვაშვეთს ასდოლარიანის წაეთამაშნენ, ხელმარჯვემ აეროპორტს რჩეულიშვილმა ნებისყოფა ფაარნები.', en: '', },
    priority: '4',
  },
  {
    id: '5',
    title: { ka: 'E-Mail Analyzes', en: 'E-Mail Analyzes', },
    description: { ka: '"E-Mail Analyzer" ეს არის ავტომატიზირებული სერვისი საეჭვო მეილების გასაანალიზებლად. "მეილ ანალაიზერი" იყენებს სხვადასხვა ღია სერვისებს როგირცაა VirusTotal, Google Safe Browsing და სხვა. გაანალიზების შემდეგ მეილი და მისი შიგთავსი ავტომატურად იშლება.<br /><br />საეჭვო მეილის მიღების შემთხვევაში გადმოაგზავნეთ მეილი scan@analyze.cert.ge-ზე და დაელოდეთ პასუხს<br />(საშუალო ლოდინის დრო 5 წუთზე ნაკლებია).', en: '', },
    priority: '5',
  },
]

export const certOptions = [
  {
    top: '118px',
    left: '72px',
    width: '164px',
    height: '162px',
  },
  {
    top: '0px',
    left: '0px',
    width: '128px',
    height: '122px',
  },
  {
    top: '0px',
    left: '184px',
    width: '128px',
    height: '122px',
  },
  {
    top: '139px',
    left: '274px',
    width: '128px',
    height: '122px',
  },
  {
    top: '279px',
    left: '190px',
    width: '128px',
    height: '122px',
  },
]